export default "__VITE_ASSET__BB4vm5zt__"